import { Agency, agencyBasic } from '@app/models';
import { corridor } from '@app/pcs/models';
import { DictionaryEntity } from '@app/pcs/models/dictionary-entity';
import { PapConstraints, papConstraints } from '@dossier/models/dossier-agencies';
import { ParameterSetCode, parameterSetCodeTemplate } from '@dossier/models/parameter-set-code';
import {gql} from 'apollo-angular';


export interface CatalogData {
  parameterSetCode?: ParameterSetCode;
  cataloguePathNumber?: string;
  corridor?: any;
  catalogueDossierType?: DictionaryEntity;
  catalogueProcessType?: DictionaryEntity;
  protectedBorder?: boolean;
  flex?: boolean;
  fix?: boolean;
  papConstraints?: PapConstraints;
  responsibleImAgency?: Agency;
}

export const pathSectionCatalogDataDetailed = gql`
    fragment pathSectionCatalogDataDetailed on CatalogData {
        parameterSetCode {
            ...parameterSetCodeTemplate
        }
        cataloguePathNumber
        corridor {
            ...corridor
        }
        catalogueDossierType {
            id
            description
        }
        catalogueProcessType {
            id
            description
        }
        responsibleImAgency {
          ...agencyBasic
        }
        protectedBorder
        flex
        fix
        papConstraints {
            ...papConstraints
        }
    }
    ${papConstraints}
    ${parameterSetCodeTemplate}
    ${corridor}
    ${agencyBasic}
`;
